import { render, staticRenderFns } from "./ContentBatch.vue?vue&type=template&id=749dc84e"
import script from "./ContentBatch.vue?vue&type=script&lang=js"
export * from "./ContentBatch.vue?vue&type=script&lang=js"
import style0 from "./ContentBatch.vue?vue&type=style&index=0&id=749dc84e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('749dc84e')) {
      api.createRecord('749dc84e', component.options)
    } else {
      api.reload('749dc84e', component.options)
    }
    module.hot.accept("./ContentBatch.vue?vue&type=template&id=749dc84e", function () {
      api.rerender('749dc84e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/batch/ContentBatch.vue"
export default component.exports